$.fancybox.defaults.touch = false;

$(document).ready(function() {
	var lang = $('html').attr('lang');

	$.reject({
		reject: {
			msie: true
		},
		display: ['chrome','firefox','opera'],
		imagePath: site_img_path + '/browser/'
	});

	/**
	 * Gestion resize + scroll
	 */
	// Resize de la fenêtre
	resize_window();
	$(window).resize(function() {
		resize_window();
	});

	// Gestion du scroll
	$(window).scroll(function() {
		if ($(window).scrollTop() > 0) {
			$('.header_parc').hide();
		} else {
			$('.header_parc').show();
		}
	});

	// Shifter
	$.shifter({
		maxWidth: '4096px'
	});

	// WOW
	new WOW().init();

	// Lazyload
	lazyload();

	// Formulaires
	if ($('.form_common').length > 0) {
		$('.form_common').each(function() {
			var form = $(this);
			form.find('input, select, textarea').each(function() {
				var field = $(this);
				field.on('focus', function() {
					field.addClass('validation');
				});
			});
		});
	}

	// Rate it
	if ($('.rateit').length > 0) {
		$('.rateit').on('click', function() {
			var rateit = $(this);
			var rateit_users_id = rateit.data('usersid');
			var rateit_produits_id = rateit.data('produitsid');
			var rateit_note = rateit.rateit('value');

			$.ajax({
				type	: "POST",
				url		: lang_path+"/produits/rateit/index.html",
				data	: 'users_id=' + rateit_users_id + '&produits_id=' + rateit_produits_id + '&note=' + rateit_note,
				error	: function(msg) {
					alert(msg);
				},
				success	: function(data) {
					rateit.rateit('readonly', true);
				}
			});
		});
	}

	// Choix parc
	$('.form_parc select').select2({
		minimumResultsForSearch: Infinity
	});
	$('.form_parc select').on('change', function() {
		$(this).parents('.form_parc').submit();
	});

	if ($('.snap_svg').length > 0) {
		$('.snap_svg').each(function() {
			var el = $(this);
			if (el.find('svg').length > 0) {
				var snap = Snap(el.find('svg')[0]);
				var path = snap.select('path');
				var pathConfig = {
					from : el.data('path'),
					to : el.data('path-hover')
				};
				var myMatrix = new Snap.Matrix();
				myMatrix.translate(0, 30);
				path.animate({transform: myMatrix}, 400, mina.backout);
				el.hover(function() {
					var myMatrix = new Snap.Matrix();
					myMatrix.translate(0, 0);
					path.animate({'path' : pathConfig.to, transform: myMatrix}, 400, mina.backout);
				}, function() {
					var myMatrix = new Snap.Matrix();
					myMatrix.translate(0, 30);
					path.animate({'path' : pathConfig.from, transform: myMatrix}, 400, mina.backout);
				});
			}
		});
	}

	if ($('.svg_blob').length > 0) {
		var svg_array = document.getElementsByClassName('svg_blob');
		var objects_array = [];

		Array.prototype.forEach.call(svg_array, function(svg) {
			var s = Snap(svg);

			const object = {
				path1 : s.select('.path1'),
				path2 : s.select('.path2'),
				path1_points : s.select('.path1').node.getAttribute('d'),
				path2_points : s.select('.path2').node.getAttribute('d'),
				to_path1 : function to_path1() {
					//this.path1.animate({ d: this.path1_points }, 5000, mina.easeinout, () => this.to_path2());
					var _this = this;
					this.path1.animate({ d: this.path1_points }, 5000, mina.easeinout, function() {
						return _this.to_path2();
					});
				},
				to_path2 : function to_path2() {
					//this.path1.animate({ d: this.path2_points }, 5000, mina.easeinout, () => this.to_path1());
					var _this = this;
					this.path1.animate({ d: this.path2_points }, 5000, mina.easeinout, function() {
						return _this.to_path1();
					});
				}
			};
			objects_array.push(object);
		});

		Array.prototype.forEach.call(objects_array, function(object_elem) {
			object_elem.to_path2();
		});
	}
});

function resize_window() {
	if ($('body').hasClass('mode_mobile')) {
		$('.bandeau').height($('.bandeau').data('height-mobile') + 'px');
	} else {
		$('.bandeau').height($('.bandeau').data('height') + 'px');
	}
}
